import {ga} from "scripts/analytics"
import l8n from "l8n"

import {partnerLoggedIn} from "./login"
import {partnerRegistered} from "./registration"
import {accessRequest} from "./integration"
import {getCurrentUser} from "./app"
import {boletoBillCaptured} from "./billing"

const eventCategory = 'Affiliates'

/**
 * Middleware for analytics
 */
const analytics = store => next => action => {
  let result = next(action)
  const state = store.getState()
  const user = getCurrentUser(state)

  switch (action.type) {
    case partnerLoggedIn.getType():
      const isGoogleSignIn = action.payload
      sendLoginEvent(user, isGoogleSignIn)
      break
    case partnerRegistered.getType():
      sendRegistrationEvent(action.payload)
      sendRdtEvent()
      break
    case accessRequest.getType():
      sendIntegrationEvent(user)
      break
    case boletoBillCaptured.getType():
      sendBoletoBillEvent(user)
      break
    default:
      break
  }

  return result
}

const sendLoginEvent = (user, isGoogleSignIn) => {
  const {cid} = user
  const eventAction = `${l8n.locale.toUpperCase()} Affiliate logged in`;
  const eventLabel = isGoogleSignIn
    ? 'Affiliate logged in with Google sign up button'
    : 'Affiliate logged in without Google sign up button';

  ga({
    ec: eventCategory,
    ea: eventAction,
    el: eventLabel,
    cid,
  })
};

const sendRegistrationEvent = (user) => {
  const {google_signin, cid} = user
  const isGoogleSignIn = !!google_signin
  const eventAction = `${l8n.locale.toUpperCase()} Affiliate registered`;
  const eventLabel = isGoogleSignIn
    ? 'Affiliate registered with Google sign up button'
    : 'Affiliate registered without Google sign up button';

  ga({
    ec: eventCategory,
    ea: eventAction,
    el: eventLabel,
    cid,
  })
};

const sendIntegrationEvent = (user) => {
  const {cid} = user
  const eventAction = `${l8n.locale.toUpperCase()} Affiliate requested integration`;

  ga({
    ec: eventCategory,
    ea: eventAction,
    cid,
  })
};

const sendBoletoBillEvent = (user) => {
  const {cid} = user

  ga({
    ec: eventCategory,
    ea: 'Boleto bill transaction captured',
    cid,
  })
}

const sendRdtEvent = () => {
  if (window.rdt && l8n.locale === 'en') {
    window.rdt('track', 'SignUp');
  }
};

export const sendVideoLessonEvent = (user) => {
  const {cid} = user

  ga({
    ec: 'Affiliate panel - left menu',
    ea: 'Video course - 10 lessons jivo settings',
    el: 'Click on the button with video course 10 lessons jivo settings',
    cid,
  })
};

export const sendVideoIntroductionEvent = (user) => {
    const {cid} = user

  ga({
    ec: 'Affiliate panel - left menu',
    ea: 'Video course - introduction course to Jivo',
    el: 'Click on the button with video introduction course to Jivo',
    cid,
  })
};

export default analytics



// WEBPACK FOOTER //
// ./src/ducks/analytics.js